import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { trackAddToCartAndRedirect } from '../utils/metaPixel';
export function Hero() {
  const goToCheckout = () => {
    trackAddToCartAndRedirect('https://www.solunetpro.com/cart/46356320452779:1');
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-20 pb-16 md:pt-32 md:pb-24" data-id="element-130">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-[#00d9ff]/10 via-[#0a0e1a] to-[#0a0e1a] -z-10" data-id="element-131" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#00d9ff]/5 rounded-full blur-[120px] -z-10" data-id="element-132" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-133">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-134">
          {/* Text Content */}
          <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-135">
            <FadeIn delay={0.1} data-id="element-136">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#ff3366]/10 border border-[#ff3366]/30 text-[#ff3366] text-sm font-semibold mb-6" data-id="element-137">
                <span className="relative flex h-2 w-2" data-id="element-138">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#ff3366] opacity-75" data-id="element-139"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-[#ff3366]" data-id="element-140"></span>
                </span>
                SISTEMA DE RESPUESTA INMEDIATA
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-141">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-142">
                El Protocolo Ex-Back AI: <br className="hidden lg:block" data-id="element-143" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d9ff] to-white" data-id="element-144">
                  Recupera el Control y Obtén una Respuesta Hoy
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-145">
              <p className="text-lg sm:text-xl text-gray-400 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-146">
                Corta el silencio y detén la ansiedad con el primer sistema de
                mensajería basado en psicología inversa e inteligencia
                artificial.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-147">
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-148">
                <Button variant="danger" size="lg" onClick={goToCheckout} className="animate-pulse-slow" data-id="element-149">
                  QUIERO RECUPERAR EL CONTROL AHORA
                </Button>
              </div>
              <p className="mt-4 text-sm text-gray-500 flex items-center justify-center lg:justify-start gap-2" data-id="element-150">
                <svg className="w-4 h-4 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-151">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-152" />
                </svg>
                Acceso instantáneo y privado
              </p>
            </FadeIn>
          </div>

          {/* Product Image */}
          <div className="order-1 lg:order-2 relative" data-id="element-153">
            <FadeIn delay={0.3} direction="left" data-id="element-154">
              <div className="relative w-full max-w-lg mx-auto" data-id="element-155">
                {/* Tech glowing frame behind image */}
                <div className="absolute inset-0 bg-gradient-to-tr from-[#00d9ff]/20 to-transparent rounded-2xl blur-2xl transform rotate-3 scale-105" data-id="element-156" />
                <motion.img src="https://cdn.magicpatterns.com/uploads/rSpZEjEXNavDGoyLv89igF/Portadaproducto.png" alt="Protocolo Ex-Back AI" className="relative z-10 w-full h-auto drop-shadow-[0_0_30px_rgba(0,217,255,0.2)]" animate={{
                y: [0, -10, 0]
              }} transition={{
                repeat: Infinity,
                duration: 6,
                ease: 'easeInOut'
              }} data-id="element-157" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}